module.exports = __webpack_public_path__ + "media/images/ticket/to_ticket_shop_ov-c923f002baa88d4b21d6fc4bc43a712d.png";